import { StatusBadge, type StatusVariant } from "@groot/ui/status-badge";

/**
 * Domain status → `StatusBadge` variant. The badge keeps the raw status text
 * as its label (as the old client did); only the token-driven tone is mapped.
 */
const ORDER_STATUS: Record<string, StatusVariant> = {
  new: "pending",
  printing: "warning",
  shipped: "info",
  delivered: "success",
  cancelled: "error",
};

const PAYMENT_STATUS: Record<string, StatusVariant> = {
  paid: "success",
  not_paid: "warning",
};

const REQUEST_STATUS: Record<string, StatusVariant> = {
  completed: "success",
  pending: "warning",
};

const PRODUCT_STATUS: Record<string, StatusVariant> = {
  active: "success",
  archived: "cancelled",
};

const TRACKING_STATE: Record<string, StatusVariant> = {
  pending: "pending",
  booked: "created",
  in_transit: "info",
  out_for_delivery: "active",
  delivered: "success",
  returned: "error",
  exception: "failed",
  not_found: "warning",
};

interface DomainBadgeProps {
  status: string;
  /** Override the displayed text (defaults to the raw status). */
  label?: string;
  className?: string;
}

interface TrackingBadgeProps {
  state: string;
  label?: string;
  className?: string;
}

export function OrderStatusBadge({ status, label, className }: DomainBadgeProps) {
  return (
    <StatusBadge
      status={ORDER_STATUS[status] ?? status}
      label={label ?? status}
      className={className}
    />
  );
}

export function PaymentStatusBadge({ status, label, className }: DomainBadgeProps) {
  return (
    <StatusBadge
      status={PAYMENT_STATUS[status] ?? status}
      label={label ?? status}
      className={className}
    />
  );
}

export function RequestStatusBadge({ status, label, className }: DomainBadgeProps) {
  return (
    <StatusBadge
      status={REQUEST_STATUS[status] ?? status}
      label={label ?? status}
      className={className}
    />
  );
}

export function ProductStatusBadge({ status, label, className }: DomainBadgeProps) {
  return (
    <StatusBadge
      status={PRODUCT_STATUS[status] ?? status}
      label={label ?? status}
      className={className}
    />
  );
}

export function TrackingStatusBadge({ state, label, className }: TrackingBadgeProps) {
  return (
    <StatusBadge
      status={TRACKING_STATE[state] ?? "pending"}
      label={label ?? state}
      className={className}
    />
  );
}
